import reductio from "reductio";

export default (reductio as any);